module.exports = __webpack_public_path__ + "img/upload.f22fdc07.svg";